import React, { useState } from "react";
import ReactPixel from "react-facebook-pixel/src/index";
import { Row, Col, Image, Card, Button, Form } from "react-bootstrap";
import "./styles.scss";
import {
  getRoofConditionImage,
  getInsuranceBtn,
} from "../../util/helper-functions/reports";
import { openPopupWidget } from "react-calendly";
import { calendlyMeetingURL } from "../../util/constants";
import { formatNumber } from "../../util/helper-functions";
import shieldImg from "../../assets/images/shield.png";
import analytics from "../../util/analytics";
import CustomCheckBox from "../Common/CheckBox";
import ReportIllustraction from "../../assets/images/report-illustration.svg";
import InsuranceLogo from "../../assets/images/insurance-logos.svg";
import EstimateLogo from "../../assets/images/estimate.svg";
import CaseBidLogo from "../../assets/images/casebid.png";
import { ReactComponent as CaseBid } from "../../assets/images/casebid.svg";
import DesktopAssessment from "../Assessment/DesktopAssessment";
import MobileAssessment from '../Assessment/MobileAssessment'

const ReportDetailsCard = ({ report, mediaQuery }) => {
  const {
    fullname,
    insurance_available,
    roof_area,
    roof_condition,
    roofing_estimate,
    property_address,
  } = report;

  function scheduleInspectionCalendly() {
    ReactPixel.track("Calendly Modal");
    analytics.track("Calendly Modal");
    return openPopupWidget({ url: calendlyMeetingURL });
  }
  console.log(mediaQuery, "SSSSSS");
  return (
    <>
      <Card className="report-card">
        <h4>
          Hi,
          <span> {fullname}</span>!
        </h4>
        <p> Here’s your Remote Roofing instant estimate </p>
        <small className="main-address-line text-muted">
          {property_address.toLowerCase()}
        </small>
        <Row>
          <Col className="pt-2" md={12}>
            <div className="d-flex align-items-center">
              <div className="mr-3">
                <img src={EstimateLogo} alt="logo" />
              </div>
              <div>
                <h6 className="report-card__roofing-estimate-title">
                  {" "}
                  RR Estimate
                </h6>
              </div>
            </div>

            <span className="report-card__roofing-estimate d-block mb-2">
              {roofing_estimate}
            </span>
            <div className="d-flex align-items-center">
              <span className="report-card__roofing-sqft d-block mb-3 text-muted mr-4 ">
                {formatNumber(Math.round(roof_area))} Sq. Ft
              </span>
              {insurance_available === "yes" && (
                <div>
                  <CustomCheckBox checked={true} />
                </div>
              )}
            </div>
            <hr style={{ border: "1px solid #C4C4C4" }} className="mb-4" />
            {
              
            }
            {
              mediaQuery ==='isDesktop'?
              <DesktopAssessment 
              isDesktop={mediaQuery==='isDesktop' ?true:false} 
              isInsurance={insurance_available ==='yes'?true :false}
              scheduleInspectionCalendly={scheduleInspectionCalendly}
              />
              :
              <MobileAssessment
              isMobile={!(mediaQuery =='isDesktop') ?true:false} 
              isInsurance={insurance_available ==='yes'?true :false}
              scheduleInspectionCalendly={scheduleInspectionCalendly}
           />
            }
     
      
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default ReportDetailsCard;
